import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory, useParams } from "react-router";
import StatusLayout from "components/Status";
import {
    Avatar,
    AvatarGroup,
    IconButton,
    Tooltip,
    Typography,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Link
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { stringAvatar } from "components/Task/TaskDetails";
import { useLocation } from "react-router";

function ProjectReport({
    category,
    SetSelectedMenu,
    FetchDetails,
    loggedUser,
}) {
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [id, setId] = React.useState();
    const [type, setType] = React.useState();
    const [count, setCount] = React.useState(0);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [resources, setResources] = React.useState([]);
    const [deleteUrl, setDeleteUrl] = React.useState();
    const history = useHistory();
    const params = useParams();
    const [challengeModalOpen, setChallengeModalOpen] = React.useState(false);
    const [currentChallenge, setCurrentChallenge] = React.useState("");

    const [statusModalOpen, setStatusModalOpen] = React.useState(false);
    const [currentStatus, setCurrentStatus] = React.useState("");

    const GetAllResources = async () => {
        const resp = await FetchDetails(`/api/resource/listAll`);
        if (resp.status) {
            const allResources = resp?.data?.data?.map((item) => ({
                label: item?.names,
                value: item?.id,
            }));
            setResources(allResources);
        }
    };

    const location = useLocation();
    const { startDate, endDate } = location.state || {};
    const reportId = location.state?.reportId || "";


    useEffect(() => {
        const categ = category ? category : params.id;
        SetSelectedMenu({
            menu: categ === "task" ? "report/project" : "report/task",
            title: categ === "task" ? "Task Report" : "Project Report",
        });
        setType(categ);
    }, [params?.id, category]);

    useEffect(() => {
        GetAllResources().then();
    }, []);

    const handleViewChallenge = (challenge) => {
        setCurrentChallenge(challenge);
        setChallengeModalOpen(true);
    };

    const handleCloseChallengeModal = () => {
        setChallengeModalOpen(false);
        setCurrentChallenge("");
    };

    const handleViewStatus = (status) => {
        setCurrentStatus(status);
        setStatusModalOpen(true);
    };

    const handleCloseStatusModal = () => {
        setStatusModalOpen(false);
        setCurrentStatus("");
    };


    const ReportApprover = ({ approvers }) => {
        return (
            <div className={"flex items-center"}>
                <AvatarGroup max={approvers?.length} sx={{}}>
                    {approvers?.map((item) => (
                        <Tooltip
                            arrow={true}
                            title={
                                <div className="flex items-center">
                                    <Typography className="me-2">
                                        {item?.Resource?.names}
                                    </Typography>
                                    <Delete
                                        role="button"
                                        fontSize="small"
                                        onClick={() => {
                                            setDeleteOpen(true);
                                            setDeleteUrl(
                                                `/api/report/delete/approver-report/${item?.id}`
                                            );
                                        }}
                                    />
                                </div>
                            }
                        >
                            <Avatar {...stringAvatar(`${item.Resource.names ?? ""}`)} />
                        </Tooltip>
                    ))}
                </AvatarGroup>
            </div>
        );
    };

    const columns = [
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) =>
                    moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "Project.name",
            label: "Project Name",
        },
        {
            name: "Project.budget",
            label: "Budget",
        },
        {
            name: "Project.impact",
            label: "Impact",
        },
        {
            name: "expense",
            label: "Used Budget",
        },
        {
            name: "status",
            label: "Overall Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const displayText = value
                        ? value.length > 10
                            ? value.substring(0, 10) + "..."
                            : value
                        : "";
                    return (
                        <Link
                            href="#"
                            onClick={(e) => 
                                e.preventDefault() ||
                                handleViewStatus(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },
        {
            name: "challenges",
            label: "Challenges",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const displayText = value
                        ? value.length > 10
                            ? value.substring(0, 10) + "..."
                            : value
                        : "";
                    return (
                        <Link
                            href="#"
                            onClick={(e) => 
                                e.preventDefault() ||
                                handleViewChallenge(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },
        {
            name: "Resource.names",
            label: "Prepared By",
        },
        {
            name: "Project.status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <StatusLayout status={value ?? "not available"} />
                ),
            },
        },
        // {
        //     name: "id",
        //     label: "Action",
        //     options: {
        //         filter: false,
        //         sort: false,
        //         customBodyRender: (v) => (
        //             <div className="flex items-center">
        //                 <IconButton
        //                     onClick={() => {
        //                         setOpen(2);
        //                         const obj = list.find(vx => vx.id === v);
        //                         setId(v);
        //                         setValue0('name', obj.name);
        //                         setValue0("projectId", obj.projectId);
        //                         setValue0("date", moment(obj.date).format("YYYY-MM-DD"));
        //                         setValue0("progress", obj.progress);
        //                         setValue0("status", obj.status);
        //                         setValue0("challenges", obj.challenges);
        //                         setValue0("budget", obj.budget);
        //                         setValue0("impact", obj.impact);
        //                         setValue0("expense", obj.expense);
        //                         setValue0("project", obj.Project.name);

        //                     }}
        //                 >
        //                     <img
        //                         src={require("../../assets/icons/pencil.svg").default}
        //                         alt="Decorative SVG"
        //                         className="mr-2 text-sm"
        //                     />
        //                 </IconButton>
        //                 <IconButton onClick={() => { setId(v); setDeleteOpen(true); }}>
        //                     <img
        //                         src={require("../../assets/icons/trash.svg").default}
        //                         alt="Decorative SVG"
        //                         className="mr-2 text-sm"
        //                     />
        //                 </IconButton>
        //             </div>
        //         ),
        //     },
        // },
    ];

    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">

            <Dialog
                open={challengeModalOpen}
                onClose={handleCloseChallengeModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <div className={"flex items-center"}>
                        <div className={"flex-grow font-bold text-lg"}>
                            <Typography variant="h6" className="mb-3">Challenge Details</Typography>
                        </div>
                        <IconButton onClick={() => handleCloseChallengeModal(false)}>
                            <img
                                src={require("assets/icons/close.svg").default}
                                alt={"close"}
                            />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentChallenge }} />
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleCloseChallengeModal} color="primary">
                        Close
                    </Button> */}
                </DialogActions>
            </Dialog>

            <Dialog
                open={statusModalOpen}
                onClose={handleCloseStatusModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <div className={"flex items-center"}>
                        <div className={"flex-grow font-bold text-lg"}>
                            <Typography variant="h6" className="mb-3">Status Details</Typography>
                        </div>
                        <IconButton onClick={() => handleCloseStatusModal(false)}>
                            <img
                                src={require("assets/icons/close.svg").default}
                                alt={"close"}
                            />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentStatus }} />
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleCloseStatusModal} color="primary">
                        Close
                    </Button> */}
                </DialogActions>
            </Dialog>
            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={deleteUrl}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={
                    open === 1 && category === "project"
                        ? "/api/report/create/project-details"
                        : open === 1 && category === "task"
                            ? "/api/report/create/task-report"
                            : open !== 1 && category === "task"
                                ? `/api/report/update/task-report/${id}`
                                : `/api/report/create/project-details/${id}`
                }
                title={open === 1 ? "Add Report" : "Edit Report"}
                fields={[

                    {
                        name: "projectId",
                        label: "Project names",
                        value: value["projectId"],
                        hidden: true,
                        setValue: (val) => setValue0("projectId", val),
                    },

                    {
                        name: "project",
                        label: "Project name",
                        value: value["project"],
                        disabled: true,
                    },
                    {
                        name: "date",
                        label: "Date",
                        type: "date",
                        value: value["date"],
                        // value: info?.date,
                        required: true,
                        setValue: (val) => setValue0("date", val),
                    },
                    {
                        name: "budget",
                        label: "Budget",
                        value: value["budget"],
                        disabled: true,
                        required: true,
                        setValue: (val) => setValue0("budget", val),
                    },
                    {
                        name: "impact",
                        label: "Impact",
                        value: value["impact"],
                        disabled: true,
                        required: true,
                        setValue: (val) => setValue0("impact", val),
                    },
                    {
                        name: "expense",
                        label: "Used Budget",
                        value: value["expense"],
                        disabled: true,
                        required: true,
                        setValue: (val) => setValue0("expense", val),
                    },

                    {
                        name: "status",
                        label: "Overall Status",
                        value: value["status"],
                        required: false,
                        type: "editor",
                        col: 12,
                        setValue: (val) => setValue0("status", val),
                    },
                    {
                        name: "challenges",
                        label: "Challenges",
                        value: value["challenges"],
                        required: false,
                        type: "editor",
                        col: 12,
                        setValue: (val) => setValue0("challenges", val),
                    },
                ]}
            />


            <DatatableComponent
                onAddNew={
                    loggedUser?.allowReports
                        ? () => {
                            setOpen(1);
                        }
                        : undefined
                }
                processData={(data) => {
                    setList(data.data);
                    return data;
                }}
                elevation={1}
                columns={columns}
                viewColumns={false}
                search={false}
                searchfield={true}
                pdf={true}
                url={`/api/report/project-report/list?count=${count}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}${reportId ? `&reportId=${reportId}` : ''}`}
                title={
                    params.id === "task"
                        ? "Weekly Reports"
                        : `Weekly Project Reports from ${startDate ? moment(startDate).format("YYYY-MM-DD") : ""
                        } to ${endDate ? moment(endDate).format("YYYY-MM-DD") : ""
                        }`
                }
            />
        </div>

    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectReport);
